import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export const CLAIM_KEY = "gaffer_claim_code";

export default function Claim() {
  const { code } = useParams();
  const nav = useNavigate();
  const { user, ready, refreshUser } = useAuth();

  useEffect(() => {
    if (!ready) return;
    const clean = (code || "").trim().toUpperCase();
    if (clean) localStorage.setItem(CLAIM_KEY, clean);
    (async () => {
      if (user) {
        // Logged in already — try to redeem immediately.
        try {
          await api.post("/redeem", { code: clean });
          toast.success("Code redeemed — you've got Premium for life! 🎉");
          refreshUser?.();
        } catch (err) {
          const d = err?.response?.data?.detail;
          if (d) toast.info(d);
        }
        localStorage.removeItem(CLAIM_KEY);
        nav("/app", { replace: true });
      } else {
        // Not logged in — send to signup; auto-redeem after they register.
        toast.success("You've got a free-access invite! Create your account to claim it.");
        nav("/register", { replace: true });
      }
    })();
  }, [ready, user, code, nav, refreshUser]);

  return <div className="min-h-screen grid place-items-center text-muted-foreground">Claiming your invite…</div>;
}
